// A/B backend routing — DISABLED (2026-07-24).
//
// Every company now resolves the backend from the Vercel env vars
// (REACT_APP_REST_API / REACT_APP_GRAPHQL_URL). The per-company override to
// the "sin Prisma" services is commented out below, not deleted, so the A/B
// can be resumed by restoring this file.
//
// Why it was disabled: the two backends share the same MongoDB but NOT the
// same GraphQL schema. The "Backend sin Prisma" service (Railway, branch
// fable-test) drifted behind master, so any field added to master made every
// query from the A/B company fail schema validation — e.g. `messageType` and
// `structuredPayload` returned `Cannot query field "messageType" on type
// "Message"` for that cohort only. The A/B assumed schema parity; it no
// longer holds while fable-test lags master.
//
// Before re-enabling: merge master into the sin-Prisma branch and redeploy it,
// so both backends expose the same schema.
//
// The module and its exported signatures are kept so callers
// (apollo/apolloClient.js, axios.js, iventas_api_v2.js, redux/store.js,
// utils/aiBotsConfig.js, utils/aiBotsMedia.js, utils/fetchFromApi.js) do not
// change.

// Company that was routed to the sin-Prisma backend while the A/B ran
// (Mobieffects iVentas). Kept for reference and to resume the cohort.
export const AB_COMPANY_ID = '5ed824990274390007afcc70';

// --- A/B override, disabled -------------------------------------------------
// Scope was REST + GraphQL HTTP only. WS subscriptions always stayed on the
// env backend (both backends share the same MongoDB, so realtime kept
// working).
//
// const AB_URLS = {
//   rest: 'https://restmongo.iventas.com',
//   graphql: 'https://graphmongo.iventas.com/',
// };
//
// let storeRef = null;
//
// function currentCompanyId() {
//   try {
//     const data = storeRef && storeRef.getState()?.user?.data;
//     return data?.company?.id ?? data?.companyId ?? null;
//   } catch (e) {
//     // Routing must never break a request: unknown state -> default backend.
//     return null;
//   }
// }
// ---------------------------------------------------------------------------

// Kept as a no-op so redux/store.js keeps calling it unchanged. Restore the
// `storeRef` assignment above when the A/B is resumed.
// eslint-disable-next-line no-unused-vars
export function attachBackendOverrideStore(store) {}

// Always false while the A/B is disabled: no company is routed away from the
// env-configured backend.
export function isAbCompany() {
  return false;
}

export function getRestApiUrl() {
  // return isAbCompany() ? AB_URLS.rest : process.env.REACT_APP_REST_API;
  return process.env.REACT_APP_REST_API;
}

export function getGraphqlUrl() {
  // return isAbCompany() ? AB_URLS.graphql : process.env.REACT_APP_GRAPHQL_URL;
  return process.env.REACT_APP_GRAPHQL_URL;
}
